// DOCTOR REGISTRATION Wizard Store
import axios from "axios"
const initialState = () => ({
  doctorReg: {
    Personal: {
      mainAddressID: "",
      firstName: "",
      lastName: "",
      title: "",
      emailAddress: "",
      cellNumber: "",
      allowSMS: "",
      mainAddressID: "",
      profileImage: "",
      isReader: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      addressType: 1,
    },
    Credentials: {
      qualification: "",
      ruCertified: "",
      certDate: "",
      specialization: "",
      subSpecialization: "",
      specialties: "",
      CAQH: "",
      NPI: "",
      LICENSE: ""
    },
    Practice: {
      mainAddressID: "",
      bizName: "",
      website: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      phone: "",
      languages: "",
      insurances: "",
      addressType: 2,
      workAddressId: "",
    },
    Comments: {
      comments: ""
    },
    EditInfo: {
      id: "",
      personID: "",
      organisations: "",
      status: "",
    }
  }
})

const state = initialState()

const getters = {
  doctorReg: (state) => {
    return state.doctorReg
  },
  drPersonal: (state) => {
    return state.doctorReg.Personal
  },
  drCredentials: (state) => {
    return state.doctorReg.Credentials
  },
  drPractice: (state) => {
    return state.doctorReg.Practice
  },
  drComments: (state) => {
    return state.doctorReg.Comments
  },
  drEditInfo: (state) => {
    return state.doctorReg.EditInfo
  }
}

const mutations = {
  RESET_DOCTOR_REG(state) {
    Object.assign(state, initialState())
  },
  SET_DOCTOR_REG(state, payload) {
    state.doctorReg = payload
  }
}

const actions = {
  clearDoctorReg({ commit }) {
    commit("RESET_DOCTOR_REG")
  },
  updateDoctorReg({ commit }, doctorData) {
    commit("SET_DOCTOR_REG", doctorData)
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
